const GENERIC_ERROR = "Something went wrong. Please try again.";

/**
 * Prefers the server's own wording over a generic apology.
 *
 * Casey refuses for reasons the client can act on -- sending too fast, too many
 * people at once -- and those messages are written for them. A rejected request
 * arrives here as an `Error` whose message is the raw response body, so the JSON
 * envelope is unwrapped. Anything that does not look like copy meant for a client
 * (a stack trace, an HTML error page) falls back to the generic line rather than
 * showing them machinery.
 */
export function clientFacingError(error?: Error): string {
  const raw = error?.message?.trim();
  if (!raw) return GENERIC_ERROR;

  if (raw.startsWith("{")) {
    try {
      const parsed = JSON.parse(raw);
      const message = parsed?.error;
      if (typeof message === "string" && message.trim()) return message.trim();
    } catch {
      // Not the envelope; fall through to the generic line.
    }
    return GENERIC_ERROR;
  }

  const looksLikeMarkupOrTrace =
    raw.includes("<") || raw.includes("Traceback") || raw.length > 200;
  return looksLikeMarkupOrTrace ? GENERIC_ERROR : raw;
}
